export const TIPOS = {
  TERCEIRO: "terceiro",
  TOMADOR: "tomador",
};
